module.exports = __webpack_public_path__ + "img/JourneyTOOLS.97b83984.png";